import { render } from "./NewQuote.vue?vue&type=template&id=ed77ec16&scoped=true"
import script from "./NewQuote.vue?vue&type=script&lang=js"
export * from "./NewQuote.vue?vue&type=script&lang=js"

import "./NewQuote.vue?vue&type=style&index=0&id=ed77ec16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed77ec16"

export default script